import * as React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { useUserState } from "~/state";

const SignInCtaSection = styled.section`
  display: none;
  @media (min-width: ${(p) => p.theme.lgBreakpoint}) {
    display: block;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;

export const SignInCta = (): JSX.Element => {
  const { isAuthenticated } = useUserState();

  return isAuthenticated ? null : (
    <SignInCtaSection>
      <p className="mb-0">
        <Link
          to={(loc) => ({
            pathname: "/signin",
            state: loc.state,
          })}
        >
          Sign in
        </Link>{" "}
        to view your email alerts and activity
      </p>
    </SignInCtaSection>
  );
};
